/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type { ListK12DistrictsCountiesQueryResponse } from '../../types/ListK12DistrictsCounties'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listK12DistrictsCounties } from '../../clients/listK12DistrictsCounties'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listK12DistrictsCountiesQueryKey = () =>
  [{ url: '/api/v1/k12/districts/counties/' }] as const

export type ListK12DistrictsCountiesQueryKey = ReturnType<
  typeof listK12DistrictsCountiesQueryKey
>

export function listK12DistrictsCountiesQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listK12DistrictsCountiesQueryKey()
  return queryOptions<
    ListK12DistrictsCountiesQueryResponse,
    ResponseErrorConfig<Error>,
    ListK12DistrictsCountiesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listK12DistrictsCounties({
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary List distinct K-12 district counties as {label, value} options
 * {@link /api/v1/k12/districts/counties/}
 */
export function useListK12DistrictsCounties<
  TData = ListK12DistrictsCountiesQueryResponse,
  TQueryData = ListK12DistrictsCountiesQueryResponse,
  TQueryKey extends QueryKey = ListK12DistrictsCountiesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListK12DistrictsCountiesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? listK12DistrictsCountiesQueryKey()

  const query = useQuery(
    {
      ...listK12DistrictsCountiesQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
